module.exports = __webpack_public_path__ + "img/064dd255-ac68-4119-b8ee-684664ccdb9d.7b5d2f4c.png";